import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AuthModal from '../components/AuthModal';
import { Eye, EyeOff } from "lucide-react";

const ROLE_REDIRECTS = {
  admin: "/dashboard",
  sales: "/dashboard",
  operations: "/dashboard",
  finance: "/dashboard",
  owner: "/dashboard",
  customer: "/dashboard",
};

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { login: executeLogin } = useAuth();
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ username, password }),
      });

      console.log("STATUS:", response.status);

      const data = await response.json();

      console.log("FULL RESPONSE:", data);

      if (!response.ok) {
        setError(data.error || "Login failed");
        return;
      }

      const fixedUser = {
        ...data.user,
        role: data.user?.role || "customer"
      };

      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(fixedUser));

      executeLogin(fixedUser.role, fixedUser);

      const pendingFilters = sessionStorage.getItem("pendingSearchFilters");
      if (pendingFilters) {
        sessionStorage.removeItem("pendingSearchFilters");
        navigate("/activeTenders", { state: JSON.parse(pendingFilters) });
      } else {
        navigate("/dashboard");
      }

    } catch (err) {
      console.error("FETCH ERROR:", err);
      setError("Server connection failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="card shadow p-4" style={{ width: '400px' }}>
        <h3 className="text-center mb-4">Login Page</h3>

        {error && (
          <div className="alert alert-danger py-2 text-center small" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="text"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter Email"
              required
              style={{ borderRadius: "5px" }}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Password</label>

            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                required
                style={{ borderRadius: "5px", paddingRight: "40px" }}
              />

              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "12px",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#2F7A87"
                }}
              >
                <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
              </span>
            </div>
          </div>

          <button
            type="submit"
            className="btn w-100"
            disabled={loading}
            style={{
              backgroundColor: "#2F7F8F",
              borderColor: "#2F7F8F",
              borderRadius: "20px",
              color: "#fff"
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#266a77";
              e.target.style.borderColor = "#266a77";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "#2F7F8F";
              e.target.style.borderColor = "#2F7F8F";
            }}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <div className="mt-2 text-center">
          <Link to="/forgot-password" size="sm" className="text-muted small">
            Forgot Password?
          </Link>
        </div>

        {/* ✅ Navigate to dashboard with state to open modal */}
        <div className="mt-2 text-center">
          <Link 
            to="#" 
            onClick={(e) => { 
              e.preventDefault(); 
              // Navigate to dashboard with state to open modal
              navigate("/dashboard", { 
                state: { openAuthModal: true, isLoginMode: false } 
              });
            }}
          >
            Create an account
          </Link>
        </div>
      </div>

      <AuthModal
        show={showAuthModal}
        onHide={() => setShowAuthModal(false)}
      />
    </div>
  );
};

export default Login;